import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useIsDesktop } from '../../style/constants';
import Accordion from './Accordion';
import { Page } from './AccordionContent';

function FAQ({ page }: FAQProps) {
  const { t } = useTranslation('howItWorks');
  const isDesktop = useIsDesktop();
  return (
    <div className={`${isDesktop ? 'w-50' : 'w-100'} px-1 pt-3`}>
      <div className="d-flex flex-column py-2 align-items-center">
        <h1 className="text-center">{t('howItWorks:FAQ')}</h1>
        <span className="custom-font-text-small-normal">
          {t('howItWorks:letUsHelp')}
        </span>
      </div>
      <div className="rounded">
        {page.map(({ title, content }) => (
          <Accordion
            title={t(title) as string}
            content={t(content) as string}
          />
        ))}
      </div>
    </div>
  );
}

export default FAQ;

interface FAQProps {
  page: Page[];
}
